module.exports = __webpack_public_path__ + "icons.0ab54153eeeca0ce0397.woff2";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/icons.woff2
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/icons.woff2
// module chunks = styles